<template>
  <div
    class="editModeOverlay position-absolute cursorPointer"
    :class="visible ? 'showOverlay' : 'hideOverlay'"
    v-if="editMode"
    @click="toggleEnableMode"
  >
    <h4>
      <i class="fa" :class="visible ? 'fa-times-circle' : 'fa-check-circle'" />
      Click to {{ visible ? 'hide' : 'show' }}
    </h4>
  </div>
</template>

<script>
export default {
  name: 'VisibilityCheckbox',

  props: ['type'],

  computed: {
    editMode() {
      return this.$store.state.lmsClient.visibility.editMode;
    },

    visibleBoxes() {
      return this.$store.state.lmsClient.visibility;
    },

    visible() {
      return this.visibleBoxes[this.type].placeholderShow;
    },
  },

  methods: {
    toggleEnableMode() {
      this.$store.dispatch('lmsClient/toggleVisibilityPlaceholder', this.type);
    },
  },
};
</script>

<style lang="stylus" scoped>
.editModeOverlay
  display flex
  flex-direction row
  flex-wrap nowrap
  justify-content center
  align-items center
  align-content stretch
  width 100%
  height 100%
  z-index 10
  border 5px dashed #6a6a6a

.editModeOverlay h4
  background-color #fff

.showOverlay
  background-color rgba(255, 255, 255, .45)

.hideOverlay
  background-color rgba(150, 150, 150, .75)
</style>
